import UriError from "components/session/UriError";
import * as React from "react";

const UriErrorContainer: React.FC = () => {
  let textToDisplay = (
    <>
      <p className="text-center" style={{ fontSize: 14 }}>
        The link you clicked is not valid, which usually happens if you tried
        copying + pasting it instead of clicking it. Please return to where you
        received the link and click it to resume your identity verification.
      </p>
    </>
  );

  return (
    <>
      <UriError>{textToDisplay}</UriError>
    </>
  );
};

export default UriErrorContainer;
